import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { serviceQueryKeys } from 'queries/services/query-keys'
import { type PagedUserDefinedServicesResponse } from 'types/api/services/service'

function fetchServices({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof serviceQueryKeys.getServices>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<PagedUserDefinedServicesResponse>(endpointWithParams)
}

/*
 * Hook to fetch a set number of services
 */
export function usePaginatedServices(
  pageSize: number,
  queryOptions?: Omit<
    QueryObserverOptions<PagedUserDefinedServicesResponse, AxiosError>,
    'queryFn' | 'queryKey'
  >
) {
  const { currentTeamId: teamId } = useAuth()

  return useQuery<PagedUserDefinedServicesResponse, AxiosError>({
    ...queryOptions,
    queryFn: fetchServices,
    queryKey: serviceQueryKeys.getServices({
      pageSize,
      teamId
    })
  })
}
